<template>
  <router-view />
</template>

<script>
import { onMounted } from "vue";
import { setVH } from "@/assets/scripts/utils/resize";
import("./assets/styles/" + process.env.VUE_APP_FONT_SRC);

export default {
  name: "App",
  setup() {
    onMounted(() => {
      setVH();
    });
  },
};
</script>

<style lang="stylus">
@import './assets/styles/reset.css'
@import './assets/styles/common.styl'

// フォント切り替え
// font = ZenMaruGothic // ローカル
font = UDDigiKyokashoPro-Regular // その他の科目
// font = NHHandwriting-Medium, UDDigiKyokashoPro-Regular // 英語

font-size = 12px

body
  -webkit-text-size-adjust 100%

#app
  font-family font
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  width 100%
  height 100vh
  height calc(var(--vh, 1vh) * 100)

//フォント毎に余白調整
h1
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    margin-top: 6.5px
.icon-movie
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-sound
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-simulation
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-work
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-document
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-practice
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-program
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-web
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-link
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-tablet
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-star
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.icon-thinking
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    padding-bottom: 3px
.contents-title-txt
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    margin-top: 5px
#side-menu-h1
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    margin-top: 5px

#side-menu-txt
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    margin-top:100px

#unit-title-h1
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    margin-top:6.5px

#side-menu-header-txt
  if font != UDDigiKyokashoPro-Regular && font != ZenMaruGothic
    margin-top:2px

//リスト表示
ul
  list-style none

// その他の科目用フォント
.font-regular
  font-family UDDigiKyokashoPro-Regular !important
.font-bold
  font-family UDDigiKyokashoPro-Bold !important

// 英語用フォント
.font-light-en
  font-family NHHandwriting-Light, UDDigiKyokashoPro-Regular !important
.font-medium-en
  font-family NHHandwriting-Medium, UDDigiKyokashoPro-Regular !important
.font-bold-en
  font-family NHHandwriting-Bold, UDDigiKyokashoPro-Bold !important
.font-heavy-en
  font-family NHHandwriting-Heavy, UDDigiKyokashoPro-Bold !important

</style>
